import SpinnerLoading from 'components/MainApp/Spiners'
import React from 'react'
import './ButtonWithLoading.css'
const ButtonWithLoading = ({title='Button', isLoading=false, w="100%"}) => {
    return (
        <button className='buttonWithLoading' type='submit' style={{width:`${w}`}}>{isLoading && <SpinnerLoading/>} {title}</button>
    )
}

export default ButtonWithLoading